import { ReactElement } from 'react';
import { Typography } from '@mui/material';
import KinnectLandingPage from './KinnectLandingPage';

const KinnectNotFoundPage = (): ReactElement => {
  return (
    <KinnectLandingPage>
      <Typography sx={{ fontFamily: 'EdmondsansMedium' }}>
        We’re sorry, but the page you’re looking for doesn’t exist.
      </Typography>
    </KinnectLandingPage>
  );
};

export default KinnectNotFoundPage;
